import EInvoiceDetailSetting from "./EInvoiceDetailSetting.vue";

export default EInvoiceDetailSetting